<template>
  <timeline-range-slider @range-change="onSliderRangeChange">
    <template #legend>
      <fish-legend
        :labels="['0-3mph', '4-12', '13-18', '19-24', '25-38', '39+']"
        :color-stops="COLORS_STOPS"
      />
    </template>
  </timeline-range-slider>
</template>
<script setup lang="ts">
///// imports /////
import { ref, watch } from 'vue'
import type { Timeline } from '@xweather/mapsgl'
import { injectXWeather } from '@/fish/providers/x-weather'
import { COLORS_STOPS, MS_DAY, MS_HOUR } from '@/fish/components/ui/wind/utils'

import TimelineRangeSlider from '@/fish/components/ui/wind/timeline-slider.vue'
import FishLegend from '@/fish/components/ui/wind/legend.vue'

///// refs and variables /////
const xWeather = injectXWeather()
const selectedIndex = ref<number>(0)

const RANGE_START_OFFSET = -3 * MS_DAY
const RANGE_END_OFFSET = 5 * MS_DAY

///// functions /////
const seekByTickIndex = (tickIndex: number, nowDate = new Date()) => {
  const tl: Timeline | undefined = xWeather.controller?.timeline
  if (!tl) {
    return
  }
  const now = nowDate.getTime()
  const windowStartMs = now + RANGE_START_OFFSET
  const targetMs = windowStartMs + tickIndex * MS_HOUR
  const targetDate = new Date(targetMs)
  tl.goToDate(targetDate)
}

const setTimelineRange = () => {
  const tl: Timeline | undefined = xWeather.controller?.timeline
  if (!tl) {
    return
  }
  tl.setStartDateUsingOffset(RANGE_START_OFFSET)
  tl.setEndDateUsingOffset(RANGE_END_OFFSET)
}

const onSliderRangeChange = (payload: { tickIndex: number }) => {
  selectedIndex.value = payload.tickIndex
  seekByTickIndex(payload.tickIndex)
}

///// lifecycle /////
watch(
  xWeather.isLoaded,
  (isLoaded) => {
    if (isLoaded) {
      setTimelineRange()
    }
  },
  { immediate: true }
)
</script>
<style scoped></style>
